import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useAppDispatch, useAppSelector } from "../../../Hooks/useStore";
import { useCallback } from "react";

export type InitialStateTypes = {
  answers: any;
};

const initialState = {
  answers: [],
} as InitialStateTypes;

export const answeredQuestionsSlice = createSlice({
  name: "answeredQuestions",
  reducers: {
    setAnswers: (state, action: PayloadAction<any>) => {
      state.answers.push(action.payload);
    },
    resetAnswers: (state) => {
      state.answers = [];
    },
  },
  initialState,
});

export const { setAnswers, resetAnswers } =
  answeredQuestionsSlice.actions || {};

export default answeredQuestionsSlice.reducer;

export const useAnsweredQuestions = () => {
  const dispatch = useAppDispatch();

  const { answers } = useAppSelector((state) => state.answeredQuestions);
  const dispatchSetAnswers = useCallback(
    (data: any) => {
      dispatch(setAnswers(data));
    },
    [dispatch],
  );

  const dispatchResetAnswers = useCallback(() => {
    dispatch(resetAnswers());
  }, [dispatch]);

  return { answers, dispatchSetAnswers, dispatchResetAnswers };
};
